'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TPADimensionsHelper = function () {
  function TPADimensionsHelper() {
    var _this = this;

    _classCallCheck(this, TPADimensionsHelper);

    this.setWixHeight = function (_ref) {
      var height = _ref.height,
          _ref$offsetTop = _ref.offsetTop,
          offsetTop = _ref$offsetTop === undefined ? 0 : _ref$offsetTop,
          partialStyleParams = _ref.partialStyleParams,
          container = _ref.container,
          numOfItems = _ref.numOfItems,
          isInfinite = _ref.isInfinite,
          setHeightImp = _ref.setHeightImp;

      var getMaxRowHeight = function getMaxRowHeight() {
        var maxByScreen = function maxByScreen() {
          return _windowWrapper2.default.screen.height * 0.6;
        }; //make sure that the gallery is not heigher than the screen
        var addLayoutHeight = function addLayoutHeight() {
          return (partialStyleParams.isSlideshow ? partialStyleParams.slideshowInfoSize || 200 : 0) + (partialStyleParams.hasThumbnails && ['top', 'bottom'].indexOf(partialStyleParams.galleryThumbnailsAlignment) >= 0 ? partialStyleParams.thumbnailSize || 120 : 0);
        };
        var addRatioFix = function addRatioFix() {
          return 1 * (partialStyleParams.isSlider ? 0.85 : 1);
        }; // for Slider you want to make sure some of the 2nd picture is showing
        var maxForOneRow = function maxForOneRow() {
          return (container.galleryWidth * 9 / 16 + addLayoutHeight()) * addRatioFix() + offsetTop;
        }; //in slideshow and thumbnails, the group ratio is calculated by the height so we need a fixed value
        var maxForEmpty = 390;
        if (numOfItems === 0) {
          return maxForEmpty;
        }
        if (partialStyleParams.isInAdi) {
          var adiLoadMoreMaxHeight = void 0;
          var adiHorizontalHeight = void 0;
          var isMobile = _utils.utils.isMobile();
          if (isMobile) {
            adiLoadMoreMaxHeight = 700;
            adiHorizontalHeight = 300;
          } else {
            adiLoadMoreMaxHeight = 2000;
            adiHorizontalHeight = 600;
          }
          if (!partialStyleParams.oneRow && !partialStyleParams.enableInfiniteScroll) {
            return Math.min(height, adiLoadMoreMaxHeight);
          } else if (partialStyleParams.oneRow) {
            return adiHorizontalHeight;
          }
        } else if (partialStyleParams.oneRow) {
          return Math.min(maxByScreen(), maxForOneRow());
        } else if (!isInfinite) {
          return maxByScreen();
        } else {
          return false;
        }
      };
      var getNeededHeight = function getNeededHeight(requestedHeight) {
        var newHeight = Math.round(requestedHeight * _this.getViewportScaleRatio());
        var should = false;
        if (isInfinite) {
          should = true;
        }
        var maxRowHeight = getMaxRowHeight();
        if ((_utils.utils.isEditor() || _utils.utils.isInAlbumsBuilder()) && maxRowHeight) {
          if (partialStyleParams.isInAdi) {
            newHeight = maxRowHeight;
            should = true;
          } else if (partialStyleParams.oneRow || !partialStyleParams.oneRow && !isInfinite) {
            //when the layout changes, if the new layout is horizontal or with the show more button, adjust the height
            should = false;
            if (newHeight > maxRowHeight || _utils.utils.isInAlbumsBuilder()) {
              //only reduce the size of the gallery
              newHeight = maxRowHeight;
              should = true;
            }
          }
        }
        return should && newHeight;
      };
      var finalSetHeight = function finalSetHeight(neededHeight, lastHeight) {
        if (neededHeight) {
          if (_utils.utils.isVerbose()) {
            console.log('updating height', neededHeight);
          }

          if (Math.abs(lastHeight - neededHeight) < 6 || neededHeight === 0) {
            if (_utils.utils.isVerbose()) {
              console.log('Skipping Wix height change: was too small ' + lastHeight + ", now it's " + neededHeight);
            }
            return lastHeight;
          } else {
            if (_utils.utils.isVerbose()) {
              console.warn('Changing wix height from: ' + lastHeight + '  to: ' + neededHeight);
            }
            setHeightImp(Math.round(neededHeight));
          }
        }
        return neededHeight;
      };

      var shouldSetHeight = function shouldSetHeight() {
        var isFirstLoad = _lodash2.default.isUndefined(_this.lastIsVertical);
        var scrollDirectionChanged = !partialStyleParams.oneRow !== _this.lastIsVertical;
        var infiniteScrollChanged = partialStyleParams.enableInfiniteScroll !== _this.lastInfiniteScroll;
        var isNewLayout = (scrollDirectionChanged || infiniteScrollChanged) && !isFirstLoad;
        var should = false;
        if (isInfinite) should = true;
        if (isNewLayout) should = true;
        updateLastValues.call(_this);
        return should;
      };
      var updateLastValues = function updateLastValues() {
        _this.lastOffsetTop = offsetTop;
        _this.lastInfiniteScroll = partialStyleParams.enableInfiniteScroll;
        _this.lastIsVertical = !partialStyleParams.oneRow;
      };

      if (height <= 0) {
        console.warn('Wix setHeight called with height less than 0');
        return;
      }
      if (shouldSetHeight.call(_this)) {
        height = Math.round(height + offsetTop);
        var lastHeight = Math.round(_this.lastHeight + _this.lastOffsetTop);
        var finalHeight = getNeededHeight.call(_this, height);
        _this.lastHeight = finalHeight;
        var newHeight = finalSetHeight(finalHeight, lastHeight);
        updateLastValues.call(_this);
        return newHeight;
      }
      return _this.lastHeight;
    };

    this.lastHeight = undefined;
    this.lastOffsetTop = undefined;
    this.lastInfiniteScroll = undefined;
    this.lastIsVertical = undefined;
  }

  //// ---------------------------------- utils --------------------------------------- ////
  //TODO - this is a duplicate of the renderUtils function, should use only one


  TPADimensionsHelper.prototype.getViewportScaleRatio = function getViewportScaleRatio() {
    //320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
    var isGallery = typeof _windowWrapper2.default !== 'undefined' && _windowWrapper2.default.isGallery;
    var shouldIgnoreRatio = _utils.utils.shouldDebug('ignoreScaleRatio') || _utils.utils.isiOS() && isGallery; // PHOT 917, this is a hack to get galleries back to their normal placement on iOS, w/o this galleries on iOS are smaller by the ratio returned here.
    if (_utils.utils.isMobile() && !_utils.utils.isMobileViewer() && _utils.utils.isSite() && !shouldIgnoreRatio) {
      return 320 / _utils.utils.getScreenWidth();
    } else {
      return 1;
    }
  };

  //// ------------------------------- protections ------------------------------------////


  TPADimensionsHelper.prototype.protectGalleryWidth = function protectGalleryWidth(width) {
    var maxGalleryWidth = void 0;
    if (_utils.utils.isSite()) {
      maxGalleryWidth = Number(_utils.utils.parseGetParam('width'));
    }

    if (_utils.utils.browserIs('chromeIos')) {
      // This can be the width calc for all galleries, but in chromeIos it must be used otherwise there is a gap on the left of the gallery.
      // Currently there is a bug with Mitzi that the width parmeter is not updating fast enough once it is fixed, use this code always.
      maxGalleryWidth = maxGalleryWidth || document.body.clientWidth;
    } else {
      maxGalleryWidth = document.body.clientWidth;
    }

    if (_utils.utils.isMobile()) {
      maxGalleryWidth = Math.floor(maxGalleryWidth / this.getViewportScaleRatio());
    }
    return Math.min(Math.floor(width), maxGalleryWidth);
  };

  TPADimensionsHelper.prototype.protectGalleryHeight = function protectGalleryHeight(height) {
    var offsetTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var galleryHeight = Math.floor(height - offsetTop);
    // if (utils.isMobile() && !utils.isiOS()) {
    // 	galleryHeight = Math.floor(galleryHeight / getViewportScaleRatio());
    // }
    return galleryHeight;
  };

  //// ------------------------------ set Wix Height --------------------------------- ////

  return TPADimensionsHelper;
}();

exports.default = new TPADimensionsHelper();